import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { withIntent } from '../../../../../util/hoc/withIntent.js';
import { Box } from '../../../../Box/Box.js';
import { MarkerContextProvider } from '../../contexts/MarkerContext.js';
import { useProgressionMarker } from './useProgressionMarker.js';

var _excluded = ["state", "size", "content"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MarkerContainer = Box;
var BaseProgressionMarker = function BaseProgressionMarker(props) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var state = props.state,
    size = props.size,
    content = props.content,
    rest = _objectWithoutProperties(props, _excluded);
  var markerContext = _objectSpread(_objectSpread({}, props), {}, {
    type: 'progression'
  });
  var markerProps = useProgressionMarker(props);
  return /*#__PURE__*/React.createElement(MarkerContextProvider, {
    value: markerContext
  }, /*#__PURE__*/React.createElement(MarkerContainer, _extends({}, markerProps, rest), content));
};
var ThemableProgressionMarker = withIntent(BaseProgressionMarker);
var ProgressionMarker = /*#__PURE__*/React.memo(ThemableProgressionMarker);

export { ThemableProgressionMarker as BaseProgressionMarker, ProgressionMarker };
//# sourceMappingURL=ProgressionMarker.js.map
